import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { SvsModalService } from "@svs/angular";
import { ChatStore } from "../../../@core/state/chat.store";
import { TosModalComponent } from "../../../@shared/tos-modal/tos-modal.component";
import { ChatInputComponent } from "../../chat-input/chat-input.component";

@Component({
  selector: "app-welcome-card",
  imports: [
    ChatInputComponent,
  ],
  templateUrl: "./welcome-card.component.html",
  styleUrl: "./welcome-card.component.scss",
})
export class WelcomeCardComponent {

  chatService = inject(ChatStore);
  private readonly modal = inject(SvsModalService);
  router = inject(Router);

  startChat(message: string) {
    this.chatService.ask(message);
    this.router.navigate(["/chat"]);
  }

  openTos() {
    this.modal.open(TosModalComponent);
  }
}
